import some from 'lodash/some'

export default {
  data() {
    return {
      apiErrors: null,
      entityErrors: null,
      loading: false,
      success: false,
      entity: null,
    }
  },
  computed: {
    mode() {
      return 'creating'
    },
    oldEntity() {
      return this.entity ? this.$store.getters[`${this.entity.target}sById`][this.entity.id] : null
    },
    hasChanges() {
      return Object.keys(this.entity.getChanges(this.mode)).length
    },
    hasApiErrors() {
      return Boolean(this.apiErrors)
    },
    hasEntityErrors() {
      return Boolean(!this.entity || some(this.entityErrors))
    },
  },
  watch: {
    entity: {
      deep: true,
      handler() {
        this.onEntityChange()
      },
    },
    hosts() {
      this.onEntityChange()
    },
    services() {
      this.onEntityChange()
    },
  },
  methods: {
    onSuccess() {

    },
    onFail() {

    },
    onEntityChange() {
      if (this.entity && this.entity.validate) {
        this.entityErrors = this.entity.validate(this.mode)
      }
    },
    reset() {
      this.apiErrors = null
      this.success = false
      this.entity = null
    },
    submit(method = 'upsert') {
      this.apiErrors = null
      this.loading = true
      return this.entity[method]().then(result => {
        this.success = true
        setTimeout(() => {
          this.onSuccess(result)
        }, 1000)
      }).catch(error => {
        this.apiErrors = error
        this.onFail(error)
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
